import { Component, OnInit } from '@angular/core';
import {MatDialog, MatDialogRef} from "@angular/material/dialog";
import {grupo} from "../../../models/grupo";
import {GrupoService} from "../../../services/grupo.service";
import {LuminariaService} from "../../../services/luminaria.service";
import {luminaria} from "../../../models/luminaria";
import {plano} from "../../../models/plano";
import {zona} from "../../../models/zona";
import {ProyectoService} from "../../../services/proyecto.service";
import {PlanoService} from "../../../services/plano.service";
import {ZonaService} from "../../../services/zona.service";
import {Localiser} from "../../../services/localiser";
import {InfoGruposComponent} from "./info-grupos/info-grupos.component";
import {concentrador} from "../../../models/concentrador";
import {ConcentradorService} from "../../../services/concentrador.service";
import {sensor} from "../../../models/sensor";
import {SensorService} from "../../../services/sensor.service";
import { ParametrosService } from 'src/app/services/parametros.service';
import { parametros } from 'src/app/models/parametros';

@Component({
  selector: 'app-lista-grupos',
  templateUrl: './lista-grupos.component.html',
  styleUrls: ['./lista-grupos.component.css']
})
export class ListaGruposComponent implements OnInit {

  page: string = "lista";
  editarLuminarias: number = 0;

  // Lista Grupos
  grupos: Array<grupo> = [];
  // Lista Luminarias
  luminarias: Array<luminaria> = [];
  luminariasReal: Array<luminaria> = [];

  // New Grupo or Edit Grupo
  idGrupo: string;
  nombre: string = "";
  descripcion: string = "";
  idFade: string = "";
  luminariasGrupo: string[] = [];
  sensoresGrupo: string[] = [];
  luminariaGuardada: boolean = false;
  sizeConcentrador: number = 0;
  concentradorSelected: concentrador = undefined;
  concentradores: Array<concentrador> = [];
  selectedError: boolean = false;
  planoSelected: plano = undefined;
  zonaSelected: zona = undefined;
  planos: Array<plano> = [];
  zonas: Array<zona> = [];
  zonasReal: Array<zona> = [];
  sensores: Array<sensor> = [];

  searcherLuminarias: string = "";

  constructor(public dialogRef: MatDialogRef<ListaGruposComponent>, private grupoService: GrupoService,
              private luminariaService: LuminariaService, public proyectoService: ProyectoService,
              public planoService: PlanoService, public zonaService: ZonaService, public localiser: Localiser,
              public matDialog: MatDialog,
              private concentradorService: ConcentradorService, private sensorService: SensorService, private parametrosService: ParametrosService) {
  }

  ngOnInit(): void {
    this.page = "lista";
    this.getGrupos();
    this.getPlanosAndZonas();
    this.getConcentradores();
    this.getSensoresPresencia();
  }

  getPlano(idPlano) {
    if (idPlano != -1) {
      let plano = this.planos.find(plano => plano.idPlano == idPlano);
      if (plano != undefined) {
        return plano.nombre;
      } else {
        return this.localiser.get("fade.groups.unassigned");
      }
    } else {
      return this.localiser.get("fade.groups.unassigned");
    }
  }

  getZona(idZona) {
    if (idZona != -1) {
      let zona = this.zonas.find(zona => zona.id == idZona);
      if (zona != undefined) {
        return zona.nombre;
      } else {
        return this.localiser.get("fade.groups.unassigned");
      }
    } else {
      return this.localiser.get("fade.groups.unassigned");
    }
  }

  getPlanosAndZonas() {
    this.planoService.getByIdProyecto(this.proyectoService.getProyectoActual().idProyecto).subscribe((result: Array<plano>) => {
      this.planos = result;
    })
    this.zonaService.getByIdProyecto(this.proyectoService.getProyectoActual().idProyecto).subscribe((result: Array<zona>) => {
      this.zonasReal = result;
      this.zonas = this.zonasReal;
    })
  }

  getConcentradores() {
    this.concentradorService.getByIdProyecto(this.proyectoService.getProyectoActual().idProyecto).subscribe((result: Array<concentrador>) => {
      this.concentradores = result;
    })
  }

  loadLuminarias() {
    this.luminarias = this.luminariasReal;
    if (this.planoSelected != null)
      this.luminarias = this.luminariasReal.filter(luminaria => luminaria.idPlano == this.planoSelected.idPlano)
    if (this.zonaSelected != null)
      this.luminarias = this.luminariasReal.filter(luminaria => luminaria.idZona == this.zonaSelected.id)
    this.luminarias = this.luminarias.filter(luminaria =>
      (luminaria.nombre.toLowerCase().includes(this.searcherLuminarias.toLowerCase())) ||
      (luminaria.idDispositivo.toLowerCase().includes(this.searcherLuminarias.toLowerCase())));
  }

  selectConcentrador(event) {
    this.getSizeConcentrador(event.value.idDispositivo);
  }

  selectPlano(event) {
    if (event.value == 'all') {
      this.planoSelected = undefined;
      this.zonaSelected = undefined;
      this.zonas = this.zonasReal;
    } else {
      this.planoSelected = this.planos.find(plano => plano.idPlano == event.value.idPlano);
      this.zonas = this.zonasReal.filter(zona => zona.idPlano == event.value.idPlano);
      if (this.zonaSelected != null && !this.zonas.includes(this.zonaSelected))
        this.zonaSelected = undefined
    }
    this.loadLuminarias();
  }

  selectZona(event) {
    if (event.value == 'all') {
      this.zonaSelected = undefined;
    } else {
      this.zonaSelected = this.zonas.find(zona => zona.id == event.value.id);
      if (this.planoSelected == null) {
        this.planoSelected = this.planos.find(plano => plano.idPlano == this.zonaSelected.idPlano);
        this.zonas = this.zonasReal.filter(zona => zona.idPlano == this.zonaSelected.idPlano);
      }
    }
    this.loadLuminarias();
  }

  changePageToNew() {
    this.page = "new";
    this.nombre = "";
    this.descripcion = "";
    this.concentradorSelected = undefined;
  }

  changePageToLista() {
    this.getGrupos();
    this.page = "lista";
  }

  getGrupos() {
    this.grupoService.getByIdProyecto(this.proyectoService.getProyectoActual().idProyecto).subscribe(result => {
      this.grupos = <Array<grupo>>result;
      this.grupos.sort(function(a, b) {
        var textA = a.nombre.toUpperCase();
        var textB = b.nombre.toUpperCase();
        return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
      });
    });
  }

  getSizeConcentrador(idConcentrador) {
    this.grupoService.getSizeConcentrador(idConcentrador).subscribe((result: number) => {
      this.sizeConcentrador = result;
    });
  }

  getLuminarias() {
    this.luminariaService.getByIdProyectoIdConcentrador(this.proyectoService.getProyectoActual().idProyecto, this.concentradorSelected.idDispositivo).subscribe(result => {
      this.luminariasReal = <Array<luminaria>> result;
      this.luminarias = this.luminariasReal;
    });
  }

  getSensoresPresencia() {
    this.sensorService.getSensoresPresenciaByIdProyecto(this.proyectoService.getProyectoActual().idProyecto).subscribe(result => {
      this.sensores = <Array<sensor>> result;
    })
  }

  getLabelHubConfirmado(boolean_label) {
    return boolean_label ? this.localiser.get("fade.groups.confirmedhub.yes") : this.localiser.get("fade.groups.confirmedhub.no");
  }

  newGrupo() {
    if (this.concentradorSelected != undefined && this.nombre.length > 0) {
      if (this.sizeConcentrador < 128) {
        this.selectedError = false;
        let grupo: grupo = {
          idGrupo: "0",
          idProyecto: this.proyectoService.getProyectoActual().idProyecto,
          idConcentrador: this.concentradorSelected.idDispositivo,
          nombre: this.nombre,
          descripcion: this.descripcion,
          idFade: undefined,
          luminariaList: [],
          sensorList: []
        }

        this.grupoService.new(grupo).subscribe(result => {
          let grupoNew: grupo = <grupo>JSON.parse(result);
          this.getLuminarias();
          this.idGrupo = grupoNew.idGrupo;
          this.nombre = grupoNew.nombre;
          this.descripcion = grupoNew.descripcion;
          this.concentradorSelected = this.concentradores.find(concentrador => concentrador.idDispositivo == grupo.idConcentrador);
          this.idFade = grupoNew.idFade;
          this.luminariasGrupo = grupoNew.luminariaList;
          this.sensoresGrupo = grupoNew.sensorList;
          this.editarLuminarias = 1;
          this.page = "edit";
        }, error => {
          console.log(error.error)
        });
      }
    } else {
      this.selectedError = true;
    }
  }

  editGrupoPage(grupo: grupo) {
    this.editarLuminarias = 0;
    this.page = "edit";
    this.idGrupo = grupo.idGrupo;
    this.nombre = grupo.nombre;
    this.descripcion = grupo.descripcion;
    this.idFade = grupo.idFade;
    this.luminariasGrupo = grupo.luminariaList;
    this.sensoresGrupo = grupo.sensorList;
    this.concentradorSelected = this.concentradores.find(concentrador => concentrador.idDispositivo == grupo.idConcentrador);
    this.getLuminarias();
  }

  updateGrupo() {
    let grupo: grupo = {
      idGrupo: this.idGrupo,
      idProyecto: this.proyectoService.getProyectoActual().idProyecto,
      idConcentrador: this.concentradorSelected.idDispositivo,
      nombre: this.nombre,
      descripcion: this.descripcion,
      idFade: this.idFade,
      luminariaList: [],
      sensorList: []
    }

    this.grupoService.update(grupo).subscribe(result => {
      this.dialogRef.close();
    }, error => {
      this.dialogRef.close();
    });

  }

  deleteGrupoPage(grupo: grupo) {
    this.page = "delete";
    this.idGrupo = grupo.idGrupo;
    this.nombre = grupo.nombre;
    this.descripcion = grupo.descripcion;
    this.luminariasGrupo = grupo.luminariaList;
    this.concentradorSelected = this.concentradores.find(concentrador => concentrador.idDispositivo == grupo.idConcentrador);
    this.getLuminarias();
    console.log(this.luminariasGrupo)
  }

  deleteGrupo() {
    this.grupoService.delete(this.idGrupo, this.concentradorSelected.idDispositivo).subscribe(result => {
      this.dialogRef.close();
    }, error => {
      this.dialogRef.close();
    });
  }

  change(idLuminaria, check) {
    this.grupoService.addLumToGrupo(this.idGrupo, this.concentradorSelected.idDispositivo, idLuminaria, check).subscribe(result => {
      if (check) {
        this.luminariasGrupo.push(idLuminaria);
        if (this.containsLuminariaYSensor(idLuminaria)) {
          this.sensoresGrupo.push(idLuminaria);
        }
      } else {
        this.luminariasGrupo.splice(this.luminariasGrupo.indexOf(idLuminaria), 1);
        if (this.containsLuminariaYSensor(idLuminaria)) {
          this.sensoresGrupo.splice(this.sensoresGrupo.indexOf(idLuminaria), 1);
        }
      }
      this.luminariaGuardada = true;
      let that = this;
      setTimeout(function () {
        that.luminariaGuardada = false;
      }, 2500);
    }, error => { });
  }

  sendMaskGrupo(idLuminaria) {
    this.grupoService.sendMasksGrupo(idLuminaria, this.concentradorSelected.idDispositivo).subscribe();
  }

  sendGetHubsMap(idLuminaria) {
    this.parametrosService.loadFromGW(idLuminaria, "MapOfHubs").subscribe((result: parametros[]) => {
      setTimeout(() => {
        this.getLuminarias();
      }, 2000);
    });
  }

  containsLuminaria(luminaria: luminaria) {
    for (let luminariaG of this.luminariasGrupo) {
      if (luminariaG == luminaria.idDispositivo) {
        return true;
      }
    }
    return false;
  }

  containsLuminariaYSensor(idLuminaria: string) {
    for (let luminariaG of this.luminariasGrupo) {
      if (luminariaG == idLuminaria &&
        this.sensores.find(sensor => sensor.idLuminaria == luminariaG)) {
        return true;
      }
    }
    return false;
  }

  containsSensor(idSensor) {
    for (let sensorG of this.sensoresGrupo) {
      if (sensorG == idSensor) {
        return true;
      }
    }
    return false;
  }

  changeSensor(idSensor, check) {
    this.grupoService.addSensorToGrupo(this.idGrupo, this.concentradorSelected.idDispositivo, idSensor, check).subscribe(result => {
      if (check) {
        this.sensoresGrupo.push(idSensor);
      } else {
        this.sensoresGrupo.splice(this.sensoresGrupo.indexOf(idSensor), 1);
      }
      this.luminariaGuardada = true;
      let that = this;
      setTimeout(function () {
        that.luminariaGuardada = false;
      }, 2500);
    }, error => { });
  }

  changeEditarLuminarias(n: number) {
    this.editarLuminarias = n;
  }

  getLuminariaById(idLuminaria) {
    return this.luminariasReal.find(lum => lum.idDispositivo == idLuminaria);
  }

  getGWMant() {
    return this.concentradores.filter(gw => !gw.panId.includes("FF"));
  }

  openInfo() {
    this.matDialog.open(InfoGruposComponent, {
      width: '50%',
      height: '40%'
    });
  }

  onCancelClick(): void {
    this.dialogRef.close();
  }

}
